module.exports = __webpack_public_path__ + "static/media/edit.37c9b58c.png";